const classes = {
	root: 'credits-ec',
	inner: 'credits-ec__inner',
	logo: 'credits-ec__logo',
	list: 'credits-ec__list',
	row: 'credits-ec__row',
	label: 'credits-ec__label',
	value: 'credits-ec__value',
}

const LOGO_URL =
	'https://d1ts5g4ys243sh.cloudfront.net/proyectos_especiales_prod/especiales/calculadora-mundial-2026-tabla-de-posiciones-resultados-pronosticos-calendario-de-partidos-copa-del-mundo-argentina-colombia-ecuador-brasil/img/logo-ec.png'

const CreditsEC = () => {
	return (
		<section className={classes.root} aria-label="Créditos">
			<div className={classes.inner}>
				<img
					className={classes.logo}
					src={LOGO_URL}
					alt="El Comercio"
					loading="lazy"
				/>

				<div className={classes.list}>
					<div className={classes.row}>
						<span className={classes.label}>Producción:</span>
						<strong className={classes.value}>Raúl Castillo</strong>
					</div>

					<div className={classes.row}>
						<span className={classes.label}>Diseño:</span>
						<strong className={classes.value}>
							Christian Marlow
						</strong>
					</div>

					<div className={classes.row}>
						<span className={classes.label}>Programación:</span>
						<strong className={classes.value}>David Condori</strong>
					</div>
				</div>
			</div>
		</section>
	)
}

export default CreditsEC
